module.exports = __webpack_public_path__ + "img/failAuditRed.ca415433.png";